module.exports = __webpack_public_path__ + "static/img/fish8.929334c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish8.png
// module id = Di+R
// module chunks = 0